import { fetchOrganizationQueryOptions } from '@/api/organizationsQueryOptions'
import { ApiErrorComponent } from '@/components/ApiErrorComponent'

import LoadProgress from '@/components/LoadProgress'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import OrganizationSidebar from '@/ui/org/OrganizationSidebar'
import { Box, Stack, Typography } from '@mui/material'

export const Route = createFileRoute(
  '/_auth/organization_/$organizationUuid'
)({
  component: OrganizationComponent,
  errorComponent: ({ error }) => {
    if (error) {
      return <ApiErrorComponent error={error as Error} />
    } else {
      return <ApiErrorComponent />
    }
  },
})

function OrganizationComponent() {
  const params = Route.useParams()
  const organizationQuery = useSuspenseQuery(
    fetchOrganizationQueryOptions(params.organizationUuid),
  )
  const organization = organizationQuery.data

  if (organizationQuery.isLoading || organizationQuery.isPending) {
    return <LoadProgress />
  }

  return (
    (<>
      <Box>
        <Typography variant="h6">{organization?.name}</Typography>
      </Box>
      <Stack direction="row" spacing={1} sx={{ px: 0 }}>
        <OrganizationSidebar organizationUuid={organization.uuid} />
        <Box sx={{width: { xs: '100%', md: `calc(100% - 240px)` }}}>
          <Outlet />
        </Box>
      </Stack>
      </>)
  );
}
